import { render, staticRenderFns } from "./BlockGridItemUser.vue?vue&type=template&id=32399401&scoped=true&"
import script from "./BlockGridItemUser.vue?vue&type=script&lang=js&"
export * from "./BlockGridItemUser.vue?vue&type=script&lang=js&"
import style0 from "./BlockGridItemUser.vue?vue&type=style&index=0&id=32399401&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32399401",
  null
  
)

export default component.exports